export default __webpack_public_path__ + "static/media/next.a725f5cb.png";